// extracted by mini-css-extract-plugin
export default {"InputForm":"InputForm_InputForm__9H7d0","HidePassword":"InputForm_HidePassword__Illyy","InputPassword":"InputForm_InputPassword__YlLjA"};